const AVAILABLE_EVENTS = new Set(['COMPLETED', 'CANCELLED', 'VOIDED', 'CUSTOMER_SIGNED']);

const TECH_STATUS = {
  ASSIGNED: { label: 'Assigned', tone: 'assigned' },
  STARTED: { label: 'Started', tone: 'working' },
  RESUMED: { label: 'Working', tone: 'working' },
  TRAVELING: { label: 'Traveling', tone: 'traveling' },
  ARRIVED: { label: 'Arrived', tone: 'traveling' },
  DIAGNOSING: { label: 'Diagnosing', tone: 'working' },
  REPAIRING: { label: 'Repairing', tone: 'working' },
  ROAD_TEST: { label: 'Road Test', tone: 'working' },
  QC: { label: 'QC', tone: 'working' },
  WAITING_PARTS: { label: 'Waiting Parts', tone: 'waiting' },
  WAITING_AUTHORIZATION: { label: 'Waiting Authorization', tone: 'waiting' },
  PAUSED: { label: 'Paused', tone: 'waiting' },
  NOTE_ADDED: { label: 'Updating Job', tone: 'working' },
  PHOTO_ADDED: { label: 'Adding Photos', tone: 'working' },
  STATUS_CHANGED: { label: 'Stage Changed', tone: 'working' },
  CUSTOMER_UPDATED: { label: 'Customer Updated', tone: 'working' },
};

export function describeTechnicianStatus(event, activeLoad = 0) {
  if (!event || AVAILABLE_EVENTS.has(event.eventType)) {
    return activeLoad > 0
      ? { label: 'Assigned', tone: 'assigned', event: null }
      : { label: 'Available', tone: 'available', event: null };
  }

  const status = TECH_STATUS[event.eventType] || {
    label: event.eventType.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, char => char.toUpperCase()),
    tone: 'working',
  };

  return { ...status, event };
}

export function eventAgeLabel(timestamp) {
  if (!timestamp) return '';
  const ms = timestamp < 10_000_000_000 ? timestamp * 1000 : timestamp;
  const minutes = Math.max(0, Math.floor((Date.now() - ms) / 60000));
  if (minutes < 1) return 'now';
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ${minutes % 60}m`;
  return `${Math.floor(hours / 24)}d`;
}
